import { useContext } from 'react';
import { L2oSummary } from '@havenengineering/module-shared-owners-library/dist/interfaces/l2oSummary';
import { MODE } from '@havenengineering/module-shared-owners-ui/dist/components/Let2OwnBreakSummary';
import { LettingConfigEntry } from 'src/types/lettingConfig';

import { LettingsContext } from '../../../contexts/lettings';
import { useScreenWidth } from '../../../hooks/useScreenWidth';
import { Let2OwnBreaksSummaryWrapper } from '../Let2OwnBreakSummaryWrapper/Let2OwnBreakSummaryWrapper';
import { Let2OwnRenewalCompletedBanner } from '../Let2OwnRenewalCompleteBanner/Let2OwnRenewalCompleteBanner';

interface CalendarBannerProps {
  let2OwnSummary?: L2oSummary;
  loading: boolean;
  skipPayment?: boolean;
  breaksNotSavedAlertEnabled?: boolean;
  accountId?: number;
  setLoading?: (value: boolean) => void;
  setRenewalError?: (value: string | null) => void;
  let2OffsetIncome?: number;
  siteFeeYear?: number;
  lettingConfig: LettingConfigEntry[];
  onContinue?: () => void;
}

export const CalendarBanner: React.FC<CalendarBannerProps> = ({
  let2OwnSummary,
  loading,
  skipPayment = false,
  breaksNotSavedAlertEnabled = false,
  accountId,
  setLoading,
  setRenewalError,
  let2OffsetIncome,
  siteFeeYear,
  lettingConfig,
  onContinue,
}) => {
  const currentDate = new Date().toISOString();
  const mobileView = useScreenWidth(960);

  const { lettingSummary, isLet2OwnRenewal, lettingAccount } =
    useContext(LettingsContext);

  if (lettingSummary?.let2Own && let2OwnSummary?.summary && !loading) {
    if (isLet2OwnRenewal) {
      return (
        <>
          <Let2OwnBreaksSummaryWrapper
            accountId={accountId}
            isLoading={loading}
            let2OwnSummary={let2OwnSummary}
            currentDate={currentDate}
            mode={MODE.RENEWAL}
            skipPayment={skipPayment}
            setLoading={setLoading}
            setRenewalError={setRenewalError}
            breaksNotSavedAlertEnabled={breaksNotSavedAlertEnabled}
            let2OffsetIncome={let2OffsetIncome && Math.abs(let2OffsetIncome)}
            siteFeeYear={siteFeeYear}
            lettingGrade={lettingAccount?.approvedLettingGrade}
            lettingConfig={lettingConfig}
            onContinue={onContinue}
          />
        </>
      );
    }

    return (
      <>
        <Let2OwnRenewalCompletedBanner
          currentDate={currentDate}
          loading={loading}
          let2OwnSummary={let2OwnSummary}
          mobileview={mobileView}
          siteFeeYear={siteFeeYear}
          lettingConfig={lettingConfig}
        />
      </>
    );
  }

  return <></>;
};
